<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiPlaneTrain } from "@mdi/js"


export default {
  name: "VacationIcon",
  components: {
    SvgIcon
  },
  data() {
    return {
        path: mdiPlaneTrain,
    }
  }
}
</script>
